import script from "./nantian-judicial.vue?vue&type=script&setup=true&lang=js"
export * from "./nantian-judicial.vue?vue&type=script&setup=true&lang=js"

import "./nantian-judicial.vue?vue&type=style&index=0&id=6fbbf0af&lang=scss&scoped=true"
import "./nantian-judicial.vue?vue&type=style&index=1&id=6fbbf0af&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\公司\\cloudeffective-official-website-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbbf0af"]])

export default __exports__